/* apps/viewer/src/app/toc-items/maint-folder-module/maint-folder-modal/maint-folder-modal.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
::ng-deep .maint-folder-container {
  width: 500px;
}
::ng-deep .maint-folder-container ::ng-deep .mat-mdc-dialog-container {
  overflow: hidden;
  padding: 0;
}
@media only screen and ((max-width: 500px) or (max-height: 400px)) {
  ::ng-deep .maint-folder-container {
    height: 100%;
    max-height: 100vh !important;
    max-width: 100vw !important;
    width: 100%;
  }
}
.action-buttons {
  margin: auto;
}
.header {
  align-items: center;
  box-sizing: border-box;
  color: #fafafa;
  display: flex;
  flex-direction: row;
  height: 50px;
  justify-content: space-between;
  padding-left: 24px;
  padding-right: 0;
}
.header ::ng-deep svg {
  height: 30px;
  width: 30px;
}
.header .icon-left {
  height: 30px;
  width: 30px;
}
.header .icon {
  align-items: center;
  cursor: pointer;
  display: flex;
  fill: #fafafa;
  height: 50px;
  justify-content: center;
  max-width: 20%;
  transition: all ease 0.3s;
  width: 50px;
}
.header .icon ::ng-deep svg {
  transition: all ease 0.3s;
}
.header .icon:hover,
.header .icon:focus {
  transition: all ease 0.3s;
}
.header .icon:hover ::ng-deep svg,
.header .icon:focus ::ng-deep svg {
  fill: #fafafa;
  transition: all ease 0.3s;
}
.content {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: auto;
  justify-content: space-between;
  margin: 20px;
  width: calc(100% - 40px);
}
.content .section {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
.content .section .slider {
  width: 100%;
}
.content .section .label,
.content .section .input {
  align-items: stretch;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  width: 100%;
}
/*# sourceMappingURL=maint-folder-modal.component.css.map */
